// extracted by mini-css-extract-plugin
export default {"modalShadow":"loadingModal_modalShadow__vSG8Q","modalui":"loadingModal_modalui__zcXux"};